module.exports = __webpack_public_path__ + "static/media/home-hero--bg-canada.017e2998.jpg";